import { Injectable, Input, Output } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

import qcompare from "qcompare";
import { Subject } from "rxjs";

export const FieldIconsMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class FieldIcon extends Clazz {
    private _fieldStartIcons: string[] = [];
    private _fieldEndIcons: string[] = [];

    private _previousIconClassMap: Map<string, Record<string, boolean>> = new Map();

    @Output()
    public fieldIconClick: Subject<{ event: Event; type: "start" | "end"; index: number }> =
      new Subject();

    public get fieldStartIcon(): string {
      return Array.isArray(this._fieldStartIcons) && this._fieldStartIcons.length > 0
        ? this._fieldStartIcons[0]
        : null;
    }

    @Input()
    public set fieldStartIcon(value: string | string[]) {
      if (Array.isArray(value)) {
        this._fieldStartIcons = value;
      } else if (value != null && typeof value === "string") {
        if (Array.isArray(this._fieldStartIcons) == false) {
          this._fieldStartIcons = [];
        }
        this._fieldStartIcons[0] = value;
      } else {
        this._fieldStartIcons = [];
      }
    }

    public get fieldEndIcon(): string {
      return Array.isArray(this._fieldEndIcons) && this._fieldEndIcons.length > 0
        ? this._fieldEndIcons[0]
        : null;
    }

    @Input()
    public set fieldEndIcon(value: string | string[]) {
      if (Array.isArray(value)) {
        this._fieldEndIcons = value;
      } else if (value != null && typeof value === "string") {
        if (Array.isArray(this._fieldEndIcons) == false) {
          this._fieldEndIcons = [];
        }
        this._fieldEndIcons[0] = value;
      } else {
        this._fieldEndIcons = [];
      }
    }

    /**
     * for more complex components /w *ngFor
     * mutually exclusive with single icon getters so not template @Input() driven
     */
    public get fieldStartIcons(): string[] {
      return this._fieldStartIcons;
    }

    // @Input()
    // public set fieldStartIcons(value: string[]) {
    //   if (Array.isArray(value)) {
    //     this._fieldStartIcons = value;
    //   }
    // }

    /**
     * for more complex components /w *ngFor
     * mutually exclusive with single icon getters so not template @Input() driven
     */
    public get fieldEndIcons(): string[] {
      return this._fieldEndIcons;
    }

    // @Input()
    // public set fieldEndIcons(value: string[]) {
    //   if (Array.isArray(value)) {
    //   this._fieldEndIcons = value;
    //   }
    // }

    protected _fieldStartIconsClasses: Record<string, boolean>[];
    protected _fieldEndIconsClasses: Record<string, boolean>[];

    /** must be overridden */
    protected iconClasses(): Record<string, boolean> {
      return {};
    }

    get startIconClasses(): Record<string, boolean> {
      return this.getIconClasses("start", 0);
    }

    get startIconsClasses(): Record<string, boolean>[] {
      let previousValue = this._fieldStartIconsClasses;
      let currentValue = this.fieldStartIcons.map((_, i) => this.getIconClasses("start", i));

      if (!qcompare(previousValue, currentValue)) {
        this._fieldStartIconsClasses = currentValue;
        return currentValue;
      }

      return previousValue;
    }

    public hasEndIcon(): boolean {
      return this._fieldEndIcons?.length > 0;
    }

    get endIconClasses(): Record<string, boolean> {
      return this.getIconClasses("end", 0);
    }

    get endIconsClasses(): Record<string, boolean>[] {
      let previousValue = this._fieldEndIconsClasses;
      let currentValue = this.fieldEndIcons.map((_, i) => this.getIconClasses("end", i));

      if (!qcompare(previousValue, currentValue)) {
        this._fieldEndIconsClasses = currentValue;
        return currentValue;
      }

      return previousValue;
    }

    protected getIconClasses(type: "start" | "end", index: number = 0): Record<string, boolean> {
      const iconId = `${type}Icon${index}`;
      let previousValue = this._previousIconClassMap.get(iconId);

      let icons: Record<string, boolean> =
        this.fieldEndIcons[index] != null && this.fieldEndIcons[index].length > 0
          ? this.fieldEndIcons[index].split(" ").reduce((obj, a) => {
              obj[a] = true;
              return obj;
            }, {})
          : {};

      let currentValue = {
        [`bfx-field-icon-${type}`]: true,
        ...icons,
        ...this.iconClasses(),
      };

      if (!qcompare(previousValue, currentValue)) {
        this._previousIconClassMap.set(iconId, currentValue);
        return currentValue;
      }

      return previousValue;
    }
  }

  return FieldIcon;
};

export const FieldIconsMixinInputs = ["fieldStartIcon", "fieldEndIcon"];
